<ion-item
  *ngIf="!showSkeleton; else skeleton"
  [ngClass]="{ 'mail--unread': !mail.read }"
  class="mail h-ionic-no-pad"
  button="true"
  mode="md"
  lines="none"
>
  <div class="mail__inner">
    <img
      class="mail__icon"
      [src]="
        'assets/images/inbox/email' + (mail.read ? '' : '-unread') + '.svg'
      "
      alt="Email"
    />
    <div class="mail__title medium-dark">{{ mail.from }}</div>
    <div class="mail__date dark mapfre-fs-xs">{{
      mail.dateTime | date: 'dd/MM/yyyy'
    }}</div>
    <div class="mail__description dark mapfre-fs-xs">{{ mail.subject }}</div>
    <img
      *ngIf="mail.sendingFile"
      class="mail__attach-file"
      src="assets/images/inbox/attach.svg"
      alt="Email"
    />
  </div>
</ion-item>

<ng-template #skeleton>
  <ion-item
    disabled
    class="mail h-ionic-no-pad"
    button="true"
    mode="md"
    lines="none"
  >
    <div class="mail__inner mail--skeleton">
      <div class="mail__icon"></div>
      <div class="mail__title"></div>
      <div class="mail__date"></div>
      <div class="mail__description"></div>
      <div class="mail__attach-file"></div>
    </div>
  </ion-item>
</ng-template>
